<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.41796 14.2642C2.05677 14.2642 1.74642 14.1335 1.48692 13.8722C1.22741 13.6108 1.09766 13.2982 1.09766 12.9345V5.10404C1.09766 4.74285 1.22741 4.4325 1.48692 4.17299C1.74642 3.91348 2.05677 3.78372 2.41796 3.78372H5.11649V2.23011C5.11649 1.86633 5.24625 1.55376 5.50576 1.29241C5.76527 1.03106 6.07562 0.900391 6.43681 0.900391H9.56287C9.92406 0.900391 10.2344 1.03106 10.4939 1.29241C10.7534 1.55376 10.8832 1.86633 10.8832 2.23011V3.78372H13.5817C13.9455 3.78372 14.2581 3.91348 14.5194 4.17299C14.7808 4.4325 14.9114 4.74285 14.9114 5.10404V12.9345C14.9114 13.2982 14.7808 13.6108 14.5194 13.8722C14.2581 14.1335 13.9455 14.2642 13.5817 14.2642H2.41796ZM2.41796 12.9345H13.5817V5.10404H2.41796V12.9345ZM6.43681 3.78372H9.56287V2.23011H6.43681V3.78372Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
